import { Box, Divider } from '@wix/design-system';
import React, { isValidElement, useCallback } from 'react';
export const CollapseListContent = /*#__PURE__*/React.memo(_ref => {
  let {
    children,
    showDividers,
    contentGap,
    dataHook,
    dividerPadding = '0 SP4'
  } = _ref;
  const renderChildrenWithDividers = useCallback(() => {
    return React.Children.map(children, (child, index) => {
      if (! /*#__PURE__*/isValidElement(child)) {
        return child;
      }
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: child.key
      }, child, showDividers && index < React.Children.count(children) - 1 && /*#__PURE__*/React.createElement(Box, {
        padding: dividerPadding
      }, /*#__PURE__*/React.createElement(Divider, {
        direction: "horizontal"
      })));
    });
  }, [children, showDividers, dividerPadding]);
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: dataHook,
    direction: "vertical",
    gap: contentGap,
    width: "100%"
  }, renderChildrenWithDividers());
});
//# sourceMappingURL=collapse-list-content.js.map